export default [
  {
    path: "/companies",
    component: require("./layout").default,
    children: [
      {
        path: "/",
        name: "companies",
        component: () => import(/* webpackChunkName: "companies" */ "./index"),
      },
      {
        path: ":id",
        props: true,
        name: "companies.show",
        component: () => import(/* webpackChunkName: "companies" */ "./show"),
      },
    ],
  },
];
